export const Mode = {
  NEW: 0,
  EDIT: 1
};

export const ElementStatus = {
  NEW: 0,
  EXISTING: 1,
};

export const DataType = {
  Object: 0,
  Array: 1,
  String: 2,
  Integer: 3,
  Boolean: 4,
  Date: 5,
};

export const Tag = {
  Info: 1,
  Reference: 2,
  Match: 3,
  Matchlist: 4,
};

export const Column = {
  Value: 0,
  Tag: 1,
  IncludeInRecipe: 2,
};

export const Types = [
  { id: 0, name: "system" },
  { id: 1, name: "product" },
  { id: 2, name: "target" },
];

export const FieldToMatch = Object.freeze({
  None: 0,
  Configuration: 1,
  ElementObject: 2,
  ElementField: 4,
});
